export default __webpack_public_path__ + "media/images/cta_blocks/upgrade_to_premium-8d2fb6913182bea704c533f1df29e713.jpg";